import fetch from '@api/fetchers';

// eslint-disable-next-line import/prefer-default-export
export const checkIfYoutubeMappingExists = ({ accessToken }) =>
  fetch('v3/user/youtube-mapping/', {
    requestType: 'GET',
    tokens: { accessToken }
  });

// eslint-disable-next-line import/prefer-default-export
export const recordYoutubeMapping = ({ youtube_id, mail_id, accessToken }) =>
  fetch('v3/user/youtube-mapping/', {
    requestType: 'POST',
    body: {
      youtube_id,
      ...(mail_id && { mail_id })
    },
    tokens: { accessToken }
  });
